module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/nudge/bell-nudge-e6d83900520db18aab5702fe964e8e13.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/nudge/bell-nudge.svg
// module id = RjEa
// module chunks = 24